<div fxLayout='column'>

    <div fxLayout='row' fxLayoutAlign='space-between center'>
        <h3 *ngIf='!isLoading' mat-dialog-title>{{formTitle}}</h3>
        <div>
            <button *ngIf='showButtonShowDraftData()' mat-icon-button color="primary" (click)="showDraft()"
                [matTooltip]="language.showDraft">
                <mat-icon>visibility</mat-icon>
            </button>
            <button *ngIf='showButtonHideDraftData()' mat-icon-button color="primary" (click)="hideDraft()"
                [matTooltip]='language.hideDraft'>
                <mat-icon>visibility_off</mat-icon>
            </button>
            <button *ngIf='showButtonSaveDraftData()' mat-icon-button color="primary"
                (click)="saveDraftData(documentEditForm.form.value)" [matTooltip]='language.saveDraft'>
                <mat-icon>mode_edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <mat-divider></mat-divider>

    <div *ngIf='isLoading' fxLayout='column' fxLayoutAlign='center center'>
        <h5>{{spinnerMessage}}</h5>
        <mat-spinner></mat-spinner>
    </div>


    <form *ngIf='!isLoading' [formGroup]='form' (ngSubmit)="save(documentEditForm.form.value)" mat-dialog-content
        #documentEditForm="ngForm" fxLayout='column' fxLayoutGap='15px'>


        <div fxLayout='row wrap' fxLayoutAlign='start center' fxLayoutGap='10px'>

            <mat-form-field fxFlex='120px' fxFlex.lt-sm='none' appearance="outline">
                <mat-label >Código</mat-label>
                <input matInput formControlName='code' autocomplete="off">
                <mat-error *ngIf="this.form.controls.code.invalid">{{ getErrorMessage(form.controls.code) }}
                </mat-error>
            </mat-form-field>

            <mat-form-field fxFlex.lt-sm='none' appearance="outline">
                <mat-label >Nombre</mat-label>
                <input matInput formControlName='name' autocomplete="off">
                <mat-error *ngIf="this.form.controls.name.invalid">{{ getErrorMessage(form.controls.name) }}
                </mat-error>
            </mat-form-field>

            <div *ngIf="!isBio">
                <mat-form-field fxFlex='none' appearance="outline">
                    <mat-label >Clientes</mat-label>
                    <mat-select formControlName='customers'
                        (openedChange)="filteredCustomers = customers; filterCustomersBy.patchValue('')"
                        [compareWith]="compareWith" multiple (selectionChange)="selectionChangeCustomerSupplier($event)">

                        <app-select-filter-component [allValues]="customers" (filteredValues)="customersFilteredValues($event)"></app-select-filter-component>

                        <mat-option *ngFor='let customer of filteredCustomers' [value]='customer'>
                            {{customer.name}} - {{customer.code}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="this.form.controls.customers.invalid">{{
                        getErrorMessage(form.controls.customers) }}
                    </mat-error>
                </mat-form-field>
                <button type="button" (click)="buttonConfig('customer', 'FormCustomerSupplierComponent', undefined ,'customersSuppliers')" mat-icon-button color="primary" aria-label="Add">
                    <mat-icon>add</mat-icon>
                </button>
            </div>

            <div>
                <mat-form-field fxFlex='none' appearance="outline">
                    <mat-label >Matriz</mat-label>
                    <mat-select [formControlName]='getMatrixControlName()' [multiple]="true"
                        (openedChange)="filteredMatrix = matrix; filterMatrixBy.patchValue('')">

                        <app-select-filter-component [allValues]="matrix" (filteredValues)="matrixFilteredValues($event)"></app-select-filter-component>

                        <mat-option value='0'>-- General --</mat-option>
                        <mat-option *ngFor='let matrix of filteredMatrix' [value]='matrix.id'>
                            {{matrix.value}} - {{matrix.code}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="this.form.controls.code.invalid">{{ getErrorMessage(form.controls.code) }}
                    </mat-error>
                </mat-form-field>
                <button type="button" (click)="buttonConfig(getMatrixControlName(), 'FormTechConfig', 'matrix', 'techConfigs')" mat-icon-button color="primary" aria-label="Add">
                    <mat-icon>add</mat-icon>
                </button>
            </div>

            <mat-slide-toggle *ngIf="isBio" color='primary' formControlName='groupReportName'>Agrupar nombre de reporte</mat-slide-toggle>
            <mat-slide-toggle color='primary' formControlName='active'>Activo</mat-slide-toggle>

        </div>

        <div fxLayout='column'>
            <div fxLayout='row'>
                <mat-form-field fxFlex='none' appearance="outline">
                    <mat-label >Ensayos</mat-label>
                    <mat-select #assaySelect [formControl]='assaySelectValue'
                        (selectionChange)="assaySelectValue.patchValue('')" [disabled]="!form.get('matrix').value && !form.get('matrixG_v2Ids').value">

                        <app-select-filter-component [allValues]="assays" (filteredValues)="assaysFilteredValues($event)"></app-select-filter-component>

                        <mat-option *ngFor='let assays of filteredAssays' [value]='assays' [disabled]="!assays.active">
                            {{assays.name}} - {{assays.code}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div cdkDropList fxLayout='row wrap' formArrayName='assayGroupAssays' fxLayoutGap='15px' fxLayoutAlign='center start' (cdkDropListDropped)="dropAssay($event)">

                <mat-card class='list-card' id='assays-list' fxFlex='45' fxFlex.lt-md='100' [class.mat-elevation-z8]="true">
                    <mat-card-subtitle>Listado Ensayos</mat-card-subtitle>
                    <mat-card *ngFor='let assay of setAssays(); let i = index' (click)='assayClicked(i)'
                        [ngClass]="{'assays-list-active': i === assaySelectedIndex}" [formGroup]='assay'
                        fxLayout='row wrap' fxLayoutAlign='start center' fxLayoutGap='10px' cdkDrag>
                        <button type='button' mat-icon-button (click)='removeAssay(i)'>
                            <mat-icon>delete</mat-icon>
                        </button>
                        <span>{{assay.controls.assay.value.name ||
                            assay.controls.assay.value.assay.name}}</span>

                    </mat-card>
                </mat-card>

                <mat-card class='list-card' id='analites-list' fxFlex='45' fxFlex.lt-md='100' >
                    <mat-card-subtitle>Listado Determinaciones</mat-card-subtitle>
                    <div cdkDropList [formGroup]='assaySelected' *ngIf='showAnaliteList()' (cdkDropListDropped)="drop($event)">
                        <mat-card *ngFor='let analite of setAnalites(); let i = index'
                            fxLayout='row wrap' fxLayoutAlign='start center' fxLayoutGap='50px' [formGroup]='analite' cdkDrag>

                            <span>{{analite.controls.assayAnalite.value.analite.name }}</span>
                            <mat-slide-toggle formControlName='analize' color='primary'>Analizar
                            </mat-slide-toggle>

                        </mat-card>
                    </div>
                </mat-card>
            </div>
        </div>

        <div>
            <button #button mat-raised-button type="button" color="primary" (click)="documentEditForm.ngSubmit.emit()"
                [disabled]="disbledSaveButton()"> <span *ngIf='!isSaving'>Guardar</span>
                <mat-spinner *ngIf='isSaving' diameter='100%'></mat-spinner>
            </button> <span *ngIf='isSaving'>{{spinnerMessage}}</span>

            <button mat-button type='button' color='warn' (click)="closeDialog()">Cancelar</button>
        </div>

    </form>


</div>
